import React from "react";

const MultipleChoiceQuestion = ({ index, questionData, onQuestionChange }) => {
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Update the specific question's data
        onQuestionChange(index, { ...questionData, [name]: value });
    };

    const handleOptionChange = (e, optionIndex) => {
        const { value } = e.target;
        const updatedOptions = [...questionData.options];
        updatedOptions[optionIndex] = value;
        onQuestionChange(index, { ...questionData, options: updatedOptions });
    };

    // Ensure there are always 4 options, filling in empty strings for missing options
    const optionsWithDefaults = [...questionData.options, "", "", "", ""].slice(0, 4);

    return (
        <div className="ml-2 mb-1">
            {/* Question Title */}
            <div className="mb-4">
                <label className="block text-sm font-medium text-grey-900 mb-2">
                    Question Title
                </label>
                <input
                    type="text"
                    name="questionTitle"
                    value={questionData.questionTitle}
                    onChange={handleInputChange}
                    placeholder="Input Text Goes Here"
                    className="w-full p-2 border border-grey-300 rounded-lg"
                />
            </div>

            {/* Options */}
            {optionsWithDefaults.map((option, optionIndex) => (
                <div key={optionIndex} className="mb-4">
                    <label className="block text-sm font-medium text-grey-900 mb-2">
                        Option {optionIndex + 1}
                    </label>
                    <input
                        type="text"
                        name={`option${optionIndex + 1}`}
                        value={option}
                        onChange={(e) => handleOptionChange(e, optionIndex)}
                        placeholder={`Option ${optionIndex + 1}`}
                        className="w-full p-2 border border-grey-300 rounded-lg"
                    />
                </div>
            ))}
        </div>
    );
};

export default MultipleChoiceQuestion;